export default __webpack_public_path__ + "static/media/plus_white.9c4f8d73.svg";